import bowser from 'yola-bowser';
import hdrm from '../../hdrm';
import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_BOTH, UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';
import DEFAULT_OPTIONS from '../constants/default-options';

const duplicateElement = (elementId, initialOptions = {}) => {
  let { strategy } = initialOptions;

  /**
   * Because of some reason, after element duplication, firefox requests
   * related assets for duplicated element using wrong base uri. Even when
   * element has correct baseURI before insertion, request is sent by wrong url.
   * As a temporary solution we have decided just to reload view if user uses firefox.
   * */
  if (bowser.firefox) {
    strategy = UPDATE_STATIC_ONLY;
  }

  if (!strategy) {
    strategy = hdrm.verifiers.hasElementAdditives(elementId) ? UPDATE_STATIC_ONLY : UPDATE_BOTH;
  }

  const options = { ...DEFAULT_OPTIONS, ...initialOptions, strategy };

  return globals.helpers.globalActionExtender({
    type: actionTypes.DUPLICATE_ELEMENT,
    payload: {
      elementId,
      options,
    },
  });
};

export default duplicateElement;
